import BrokerHome from "@/pages/broker";
import BusinessHome from "@/pages/business";

import IsBusinessModal from "../components/IsBusinessModal";
import auth from "@/services/auth";
import Links from "@/constants/Links";

export default function Index() {
  // We want to let non-logged-in users switch, but once they've
  // created an account it's too late to switch.
  const forceShow = !auth.isAuthenticated();
  return (
    <>
      <BusinessHome />
      <IsBusinessModal
        businessRoute={Links.BUSINESS}
        businessComponent={<BusinessHome />}
        brokerRoute={Links.BROKER}
        brokerComponent={<BrokerHome />}
        forceShow={forceShow}
      />
    </>
  );
}
